export class PaymentError extends Error {
    constructor() {
        super('Your transaction was declined.\nPlease use a different payment method or contact your bank.');
    }
}